import {ErrorWrapper, ResponseWrapper} from '@/core/service/util'
import {RoomBaseApiService} from '@/core/service/room.baseapi.service'

class RoomFileService extends RoomBaseApiService {
  constructor() {
    super()
  }
  
  async getRoomFileList(data = {}) {
    try {
      const response = await this.request().get(
          `/api/v3/room/${this.getRoomId()}/files`,
          {
            ...data
          }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async getUploadUrl (uploadObj) {
    try {
      const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/file/upload/url`, uploadObj)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async uploadToPresignedUrl ({signal, onUploadProgress, url, ...data}) {
    try {
      let {file} = data;
      const response = await this.request({ auth: false }).put(url, file, {
        headers: {
          'Content-Type': file.type,
          'x-ms-blob-type': 'BlockBlob',
        },
        withCredentials: false,
        onUploadProgress,
        signal
      })
      return new ResponseWrapper(response, response)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  async uploadToSasUrl ({signal, onUploadProgress, url, ...data}) {
  try {
    let {file} = data;
    const response = await this.request({ auth: false }).put(url, file, {
      headers: {
        'Content-Type': file.type,
        'x-ms-blob-type': 'BlockBlob',
      },
      withCredentials: false,
      onUploadProgress,
      signal
    })
    return new ResponseWrapper(response, response)
  } catch (error) {
    throw new ErrorWrapper(error)
  }
}

  async completeUploadToPresignedUrl (data) {
    try {

      const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/file/upload/complete`, {
        ...data
      })
      return new ResponseWrapper(response, response)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  
  // async uploadRoomFile ({onUploadProgress, ...data}) {
  //   try {
  //     const formData = new FormData();
  //     for (let key in data ) {
  //       formData.append(key, data[key]);
  //     }
  //    
  //     const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/file/register`, formData, {
  //       onUploadProgress
  //     })
  //     return new ResponseWrapper(response, response.data.data)
  //   } catch (error) {
  //     throw new ErrorWrapper(error)
  //   }
  // }
  
  async deleteRoomFile (data={}) {
    try {
      const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/file/delete`, {
        ...data
      })
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
  
  async getRoomFileUrl (data={}) {
    try {
      const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/file/download/url`, {
        ...data
      })
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
}

export const roomFileService = new RoomFileService()
